<nz-card>
  <nz-skeleton [nzActive]="true"
    [nzLoading]="true"
    [nzAvatar]="false"
    [nzParagraph]="{ rows: 9 }">
  </nz-skeleton>
</nz-card>